import { createSlice } from "@reduxjs/toolkit";

const currencySlice = createSlice({
    name: "currencyStoreModule",
    initialState: {
        currency: "NIS"
    },
    reducers: {
        setGlobalCurrency: (state, action) => {
            state.currency = action.payload;
        },
    },
});

export const { setGlobalCurrency } = currencySlice.actions;

export const CurrencyReducer = currencySlice.reducer;